import { endpoints } from "../../site/configuration/endpoints";
import { OfferDetailsResponse } from "../types/Basket/OfferDetailsResponse";
import { OfferOrderDetailsRequest } from "../types/Basket/OfferOrderDetailsRequest";
import { OfferOrderHistoryRequest } from "../types/Basket/OfferOrderHistoryRequest";
import { OfferHistoryResponse } from "../types/Basket/OfferHistoryResponse";
import { OrderDetailsResponse } from "../types/Basket/OrderDetailsResponse";
import { OrderHistoryResponse } from "../types/Basket/OrderHistoryResponse";
import ApiGateway from "./ApiGateway";
import { OfferPdfRequest } from "../types/Basket/OfferPdfRequest";
import { PdfResponse } from "../types/Basket/PdfResponse";
import { OrderPdfRequest } from "../types/Basket/OrderPdfRequest";
import { OrderShippingDocumentsRequest } from "../types/Basket/OrderShippingDocumentsRequest";
import { OrderShippingDocumentsResponse } from "../types/Basket/OrderShippingDocumentsResponse";
import { CancelTokenSource } from "axios";

export class OfferOrderService {
    public getOfferHistory = (request: OfferOrderHistoryRequest): Promise<OfferHistoryResponse> => {
        return new Promise<OfferHistoryResponse>((resolve, reject) => {
            ApiGateway()
               .post<OfferHistoryResponse>(
                    endpoints.orderoffer.getOfferHistory, 
                    request)
               .then((result) => {
                    resolve(result.data)
                })    
               .catch((error) => {
                    reject(error);
                });
        });
    };
    public getOrderHistory = (request: OfferOrderHistoryRequest): Promise<OrderHistoryResponse> => {
        return new Promise<OrderHistoryResponse>((resolve, reject) => {
            ApiGateway()
               .post<OrderHistoryResponse>(
                    endpoints.orderoffer.getOrderHistory, 
                    request)
               .then((result) => {
                    resolve(result.data)
                })    
               .catch((error) => {
                    reject(error);
                });
        });
    };

    public getOfferDetails = (request: OfferOrderDetailsRequest, current: CancelTokenSource): Promise<OfferDetailsResponse> => {
        return new Promise<OfferDetailsResponse>((resolve, reject) => {
            ApiGateway()
               .post<OfferDetailsResponse>(
                    endpoints.orderoffer.getOfferDetails,
                    request, {
                        cancelToken: current.token
                    })
               .then((result) => {
                    resolve(result.data)
                })    
               .catch((error) => {
                    reject(error);
                });
        });
    }
    public getOfferPdf = (request: OfferPdfRequest): Promise<PdfResponse> => {
        return new Promise<PdfResponse>((resolve, reject) => {
            ApiGateway()
               .post<PdfResponse>(
                    endpoints.orderoffer.getOfferPdf,
                    request)
               .then((result) => {
                    resolve(result.data)
                })
               .catch((error) => {
                    reject(error);
                });
        }); 
    }
    public getOrderDetails = (request: OfferOrderDetailsRequest, current: CancelTokenSource): Promise<OrderDetailsResponse> => {
        return new Promise<OrderDetailsResponse>((resolve, reject) => {
            ApiGateway()
               .post<OrderDetailsResponse>(
                    endpoints.orderoffer.getOrderDetails,
                    request, {
                        cancelToken: current.token
                    })
               .then((result) => {
                    resolve(result.data)
                })    
               .catch((error) => {
                    reject(error);
                });
        });
    }
    public getOrderPdf = (request: OrderPdfRequest): Promise<PdfResponse> => {
        return new Promise<PdfResponse>((resolve, reject) => {
            ApiGateway()
               .post<PdfResponse>(
                    endpoints.orderoffer.getOrderPdf,
                    request)
               .then((result) => {
                    resolve(result.data)
                })
               .catch((error) => {
                    reject(error);
                });
        });
    }
    public getOrderShippingDocuments = (request: OrderShippingDocumentsRequest): Promise<OrderShippingDocumentsResponse> => {
        return new Promise<OrderShippingDocumentsResponse>((resolve, reject) => {
            ApiGateway()
               .post<OrderShippingDocumentsResponse>(
                    endpoints.orderoffer.getOrderShippingDocuments,
                    request)
               .then((result) => {
                    resolve(result.data)
                })
               .catch((error) => {
                    reject(error);
                });
        });
    }
}